export class User {
  '_id': string;
  'userName': string;
  'password': string;
}
